import { Link, useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "../../App";
import CheckToken from "../../_Login/CheckToken";
import toast, { Toaster } from 'react-hot-toast';
import GetJobResults from "../Tools/OilerGetJobResults";
import GetAddresses from "../Tools/OilersGetAddresses";
import OilerSave from "../Tools/OilerSave";


const OilersNew = () => {

    const [user, setUser] = useContext(UserContext);
    let navigate = useNavigate();
    CheckToken(user["id"], user["token"]).then((result) => { if (!result) { setUser({}); navigate("/Login"); } });

    const [jobResults, setJobResults] = useState([]);
    const [selectedJob, setSelectedJob] = useState({ jobNum: "", customer: "" });
    const [siteLocations, setSiteLocations] = useState([]);

    const handleJobSearch = (e) => {

        let searchcriteria = e.target.value;
        if (searchcriteria.length > 2) {
            GetJobResults(searchcriteria)
                .then((result) => {
                    if (result.success) {

                        let jobsList = [];
                        let myJobs = JSON.parse(result.payload).data;

                        myJobs.forEach((job) => {
                            jobsList.push({
                                jobNum: job[0],
                                customer: job[1]
                            });
                        });

                        setJobResults(jobsList);

                    }
                });
        }
        else {
            setJobResults([]);
        }

    };

    const handleJobSelect = (job) => {
        setSelectedJob(job);
        setJobResults([]);
        // disable the input
        document.getElementById("JobNum").disabled = true;
        //add a checkmark to the selected job
        let jobNum = document.getElementById("JobNum");
        jobNum.value = `${job.jobNum} ${job.customer ? `(${job.customer})` : ""} ✓`;

        if (job.customer == "" || job.customer == null || job.customer == undefined || job.customer.length == 0) {
            toast.error("Customer is missing from the job. Please select a different job.");
            return;
        }
        GetAddresses(job.customer)
            .then((result) => {
                if (result.success) {
                    const mySiteLocations = JSON.parse(result.payload).data;
                    let siteList = [];

                    mySiteLocations.forEach((entry, index) => {

                        let a_name = entry[1] == "" ? "[No Name]" : entry[1];
                        let l1 = entry[2] == "[No Address]" ? "" : entry[2];
                        let l2 = entry[3] == "" ? "" : entry[3];
                        let city = entry[4] == "" ? "[No City]" : entry[4];
                        let state = entry[5] == "" ? "[No State]" : entry[5];
                        let zip = entry[6] == "" ? "[No Zip]" : entry[6];

                        let obj = {
                            AdressID: entry[0],
                            AdressName: a_name,
                            Line1: l1,
                            Line2: l2,
                            City: city,
                            State: state,
                            Zip: zip,
                            siteString: `${a_name} ${l1} ${l2}, ${city}, ${state} ${zip}`
                        };

                        siteList.push(obj);
                    });
                    setSiteLocations(siteList);
                }
            });
    };

    const handleClearAll = () => {

        document.getElementById("JobNum").value = "";
        document.getElementById("JobNum").disabled = false;
        document.getElementById("SiteAddress").value = "";
        document.getElementById("NumTestPoints").value = "";
        document.getElementById("InFeedSensorDistance").value = "";
        document.getElementById("Notes").value = "";

        setSelectedJob({ jobNum: "", customer: "" });
        setJobResults([]);
        setSiteLocations([]);

        //....
    };

    const handleSubmit = (e) => {

        //validate the form

        let jobNum = document.getElementById("JobNum").value;
        let siteAddress = document.getElementById("SiteAddress").value;
        let numTestPoints = document.getElementById("NumTestPoints").value;
        let inFeedSensorDistance = document.getElementById("InFeedSensorDistance").value;
        let notes = document.getElementById("Notes").value;

        if (jobNum == "" || jobNum == null || jobNum == undefined) {
            toast.error("Job is required.");
            return;
        }

        if (siteAddress == "" || siteAddress == null || siteAddress == undefined) {

            toast.error("Site Address is required.");
            return;
        }

        if (numTestPoints == "" || numTestPoints == null || numTestPoints == undefined) {
            toast.error("Number of Test Points is required.");
            return;
        }

        if (inFeedSensorDistance == "" || inFeedSensorDistance == null || inFeedSensorDistance == undefined) {
            toast.error("In-Feed Sensor Distance is required.");
            return;
        }

        if (notes == "" || notes == null || notes == undefined) {
            toast.error("Notes are required.");
            return;
        }

        OilerSave("", selectedJob.jobNum, numTestPoints, inFeedSensorDistance, siteAddress, user["id"], notes)
            .then((result) => {
                if (result.success) {
                    toast.success("Oiler saved successfully.");
                    navigate("/Oilers");
                }
                else {
                    toast.error("There was an error saving the Oiler.");
                }
            });
    };

    document.title = "Oilers - New";
    return (
        <div className="oilerNew">

            {user["email"] != undefined &&
                <>
                    <div className="container body-content" style={{ marginTop: "25px" }}>

                        <div style={{ display: "flex", flexDirection: "row", margin: "0px", justifyContent: "space-between" }}>
                            <Link to="/Oilers" className="btn btn-default" style={{ width: "auto" }}>Back</Link>
                            <button onClick={handleClearAll} className="btn btn-warning" style={{}}>Start Over</button>
                        </div>

                        <h2>New Oiler</h2>

                        <div className="card" style={{ marginTop: "1%", marginBottom: "1%" }}>

                            <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>Job & Customer Information</div>

                            <div className="card-body">
                            
                                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                    <div className="form-group" style={{ width: "48%", margin: "1%" }}>
                                        <label htmlFor="JobNum">Job</label>
                                        <input type="text" onChange={(e) => { handleJobSearch(e) }} placeholder="Search jobs..." className="form-control" id="JobNum" name="JobNum" style={{ width: "100%", minWidth: "100%", marginBottom: "16px" }} autoComplete="off" />
                                    </div>
                                    <div className="form-group" style={{ width: "48%", margin: "1%" }}>
                                        <label htmlFor="SiteAddress">Site Address</label>
                                        <select className="form-control" id="SiteAddress" name="SiteAddress" style={{ width: "100%", minWidth: "100%", marginBottom: "16px" }} 
                                            disabled={siteLocations.length == 0 ? true : false}
                                        >
                                            <option value="">Select Site Address...</option>
                                            {siteLocations != undefined && siteLocations.length > 0 &&
                                                siteLocations.map((site, index) => {
                                                    return (
                                                        <option key={index} value={site.AdressID}>{site.siteString}</option>
                                                    );
                                                })
                                            }
                                        </select>
                                    </div>
                                </div>

                                <div className="form-group" style={{ display: "flex", flexDirection: "column", flexWrap: "wrap", width: "25%" }}>
                                    {jobResults.length > 0 && <label htmlFor="JobResults">Select Job...</label>}
                                    {jobResults != undefined && jobResults.length > 0 &&
                                        jobResults.map((job, index) => {
                                            return (
                                                <button key={index} onClick={() => { handleJobSelect(job) }} className="btn btn-secondary" style={{ borderRadius: "0px", marginTop: "1px" }}>
                                                    {job.jobNum} {job.customer ? `(${job.customer})` : ""}
                                                </button>
                                            );
                                        })
                                    }
                                </div>

                            </div>
                        </div>

                        <div className="card" style={{ marginTop: "1%", marginBottom: "1%" }}>

                            <div className="card-header" style={{ fontSize: "20px", backgroundColor: "#158cba", color: "var(--bs-light)" }}>
                                Oiler Test Information
                            </div>

                            <div className="card-body">

                                <div style={{ display: "flex", flexDirection: "row", width: "100%" }}>
                                    <div className="form-group" style={{ width: "48%", margin: "1%" }}>
                                        <label htmlFor="NumTestPoints">Number of Test Points</label>
                                        <select className="form-control" id="NumTestPoints" name="NumTestPoints" style={{ width: "100%", minWidth: "100%" }}>
                                            <option value="">Select Number of Test Points...</option>
                                            <option value="2">2</option>
                                            <option value="3">3</option>
                                            <option value="4">4</option>
                                            <option value="5">5</option>
                                            <option value="6">6</option>
                                            <option value="7">7</option>
                                            <option value="8">8</option>
                                            <option value="9">9</option>
                                            <option value="10">10</option>
                                        </select>
                                    </div>

                                    <div className="form-group" style={{ width: "48%", margin: "1%" }}>
                                        <label htmlFor="InFeedSensorDistance">In-Feed Sensor Distance&nbsp;<span className="text-secondary">(in)</span></label>
                                        <input type="number" placeholder="Enter distance..." className="form-control" id="InFeedSensorDistance" name="InFeedSensorDistance" style={{ width: "100%", minWidth: "100%" }} />
                                    </div>
                                </div>

                                <div className="form-group" style={{ width: "98%", margin: "1%" }}>
                                    <label htmlFor="Notes">Notes</label>
                                    <textarea placeholder="Notes..." className="form-control" id="Notes" name="Notes" style={{ width: "100%", minWidth: "100%", height: "128px" }}></textarea>
                                </div>

                            </div>
                        </div>

                        <div style={{ display: "flex", flexDirection: "row", width: "1140px", marginBottom: "8px", marginTop: "8px", justifyContent: "space-between" }}>
                            <Link to="/Oilers" className="btn btn-default" style={{ marginRight: "4px", width: "auto" }}>Back</Link>
                            <button className="btn btn-success" onClick={handleSubmit} style={{ margin: "0px", width: "128px" }}>Submit</button>
                        </div>
                    </div>
                </>
            }
        </div>
    );
}

export default OilersNew;